import { useCallback, useState } from "react";
import formatters from "../../utils/formatters";
import { DatePicker } from "../../components/inputs";
import {
  ArrowDownwardOutlined,
  ArrowUpwardOutlined,
  AttachMoneyOutlined,
  HomeWorkOutlined,
} from "@material-ui/icons";
import React from "react";
import Loader from "../../components/loaders";

const CardProducaoDia = ({
  producaoDia,
  getProducao,
  getListaConsultasDia,
}) => {
  const [selectedDate, setSelectedDate] = useState(new Date());

  const handleDateChange = useCallback(
    (value) => {
      setSelectedDate(value);
      getProducao(value, value);
    },
    [getProducao]
  );

  return (
    <div className="card" style={{ minHeight: 100 }}>
      <div className="card-body d-flex flex-column">
        {!!producaoDia.loading && (
          <div className="row">
            <div className="col-12 d-flex justify-content-center">
              <Loader type={"dots"} color={"brand"} size={80} />
            </div>
          </div>
        )}
        {!producaoDia.loading && (
          <>
            <div
              className={"row d-flex align-items-center justify-content-center"}
            >
              <div className="card-title-dashboard color-brand">
                Produção de{" "}
                <DatePicker
                  disableFuture
                  variant={"outline"}
                  margin="none"
                  fullWidth={false}
                  format="dd/MM/yyyy"
                  value={selectedDate}
                  className={"card-date-picker"}
                  onChange={handleDateChange}
                  InputProps={{
                    disabled: true,
                  }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-6 mt-3">
                <div
                  className={"d-flex align-items-center justify-content-center"}
                >
                  <AttachMoneyOutlined
                    style={{ fontSize: 56, color: "grey" }}
                  />
                </div>
                <div
                  className={
                    "d-flex align-items-center justify-content-center mt-2"
                  }
                >
                  <div className="colored-card-data">
                    {producaoDia.data.valor > 0
                      ? producaoDia.data.valor / 1000000 > 1
                        ? formatters.numbers.nFixed(
                            producaoDia.data.valor / 1000000,
                            2
                          ) + "M"
                        : formatters.numbers.simple(
                            producaoDia.data.valor / 1000
                          ) + "K"
                      : 0}
                  </div>
                </div>
                <div
                  className={"d-flex align-items-center justify-content-center"}
                >
                  <span className="colored-card-text">Reais</span>
                </div>
                <div className="mt-3 justify-content-center">
                  <div
                    className={
                      "d-flex align-items-center justify-content-center"
                    }
                  >
                    {(producaoDia.data.percDiffValor === 0 ||
                      !producaoDia.data.percDiffValor) && (
                      <span className="colored-card-data">-</span>
                    )}
                    {!(producaoDia.data.percDiffValor === 0) &&
                      !!producaoDia.data.percDiffValor && (
                        <>
                          {producaoDia.data.percDiffValor > 0 && (
                            <ArrowUpwardOutlined className="producao-alta" />
                          )}
                          {producaoDia.data.percDiffValor < 0 && (
                            <ArrowDownwardOutlined className="producao-baixa" />
                          )}
                          <span
                            className={
                              producaoDia.data.percDiffValor < 0
                                ? "producao-baixa colored-card-text ml-2 d-inline-block"
                                : "colored-card-text ml-2 d-inline-block producao-alta"
                            }
                          >
                            {formatters.numbers.currency(
                              producaoDia.data.percDiffValor
                            )}{" "}
                            %
                          </span>
                        </>
                      )}
                  </div>
                </div>
              </div>
              <div className="col-6 mt-3">
                <div
                  className={"d-flex align-items-center justify-content-center"}
                >
                  <HomeWorkOutlined style={{ fontSize: 56, color: "grey" }} />
                </div>
                <div
                  className={
                    "d-flex align-items-center justify-content-center mt-2"
                  }
                >
                  <div
                    className="colored-card-data clickable"
                    onClick={getListaConsultasDia}
                  >
                    {producaoDia.data.quantidade}
                  </div>
                </div>
                <div
                  className={"d-flex align-items-center justify-content-center"}
                >
                  <span className="colored-card-text">
                    {producaoDia.data.quantidade === 1
                      ? "Contrato"
                      : "Contratos"}
                  </span>
                </div>
                <div className="mt-3">
                  <div
                    className={
                      "d-flex align-items-center justify-content-center"
                    }
                  >
                    {(producaoDia.data.percDiffQuantidade === 0 ||
                      !producaoDia.data.percDiffQuantidade) && (
                      <span className="colored-card-data">-</span>
                    )}
                    {!(producaoDia.data.percDiffQuantidade === 0) &&
                      !!producaoDia.data.percDiffQuantidade && (
                        <>
                          {producaoDia.data.percDiffQuantidade > 0 && (
                            <ArrowUpwardOutlined className="producao-alta" />
                          )}
                          {producaoDia.data.percDiffQuantidade < 0 && (
                            <ArrowDownwardOutlined className="producao-baixa" />
                          )}
                          <span
                            className={
                              producaoDia.data.percDiffQuantidade < 0
                                ? "producao-baixa colored-card-text ml-2 d-inline-block"
                                : "colored-card-text ml-2 d-inline-block producao-alta"
                            }
                          >
                            {formatters.numbers.currency(
                              producaoDia.data.percDiffQuantidade
                            )}{" "}
                            %
                          </span>
                        </>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CardProducaoDia;
